import Sidebar from "../components/Sidebar/Sidebar";
import PageBanner from "../components/PageBanner/PageBanner";
import Loader from "../components/Loader/Loader";

// Stil dosyası
import "./SinglePostPage.scss";

import bannerBg from "../assets/images/slider0.jpg";

import React, { useState, useEffect } from "react";
import { useParams, Link } from "react-router-dom";
import { supabase } from "../supabaseClient";

import { FaRegCommentDots } from "react-icons/fa";

const SinglePostPage = () => {
  const { slug } = useParams(); // URL'den slug'ı alıyoruz
  const [post, setPost] = useState(null);
  const [comments, setComments] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // Form State'leri
  const [commentAuthor, setCommentAuthor] = useState("");
  const [commentText, setCommentText] = useState("");
  const [formMessage, setFormMessage] = useState("");

  // 1. useEffect: URL'deki slug'a göre ana yazıyı çek
  useEffect(() => {
    const fetchPost = async () => {
      setLoading(true);
      const { data, error } = await supabase
        .from("posts")
        .select("*")
        .eq("slug", slug)
        .single(); // Sadece tek bir sonuç beklediğimizi belirtiyoruz

      if (error) {
        setError("Yazı bulunamadı veya bir hata oluştu.");
        console.error(error);
      } else {
        setPost(data);
      }
      // Bu aşamada yüklemeyi kapatmıyoruz, çünkü yorumları da çekeceğiz
    };

    fetchPost();
  }, [slug]); // slug değiştiğinde bu fonksiyon yeniden çalışır

  // 2. useEffect: Yazı verisi geldikten sonra, o yazıya ait yorumları çek
  useEffect(() => {
    if (post) {
      const fetchComments = async () => {
        const { data, error } = await supabase
          .from("comments")
          .select("*")
          .eq("post_id", post.id)
          .eq("is_approved", true) // Sadece onaylanmış yorumları göster
          .order("created_at", { ascending: false });

        if (error) {
          setError("Yorumlar yüklenirken bir hata oluştu.");
          console.error(error);
        } else {
          setComments(data);
        }
        setLoading(false); // Hem yazı hem yorumlar yüklendi, şimdi yüklemeyi bitir
      };

      fetchComments();
    }
  }, [post]); // post state'i güncellendiğinde bu fonksiyon çalışır

  // Yorum gönderme fonksiyonu
  const handleCommentSubmit = async (e) => {
    e.preventDefault();
    setFormMessage("");

    const { error } = await supabase.from("comments").insert([
      {
        author_name: commentAuthor,
        comment_text: commentText,
        post_id: post.id,
        // is_approved varsayılan olarak false olduğu için belirtmemize gerek yok
      },
    ]);

    if (error) {
      setFormMessage("Yorumunuz gönderilirken bir hata oluştu.");
      console.error(error);
    } else {
      setFormMessage("Yorumunuz onaya gönderildi. Teşekkür ederiz!");
      setCommentAuthor("");
      setCommentText("");
    }
  };

  if (error) {
    return (
      <div className="page-container">
        <p>{error}</p>
      </div>
    );
  }

  return (
    <div className="single-post-page">
      <PageBanner title={post ? post.title : "..."} bgImage={bannerBg} />

      <div className="page-content-wrapper">
        {loading ? (
          // Yükleniyorsa Loader'ı göster
          <div className="full-width-loader">
            <Loader />
          </div>
        ) : post ? (
          <>
            <div className="blog-content-column">
              <div className="post-hero-image">
                <img src={post.image_url} alt={post.title} />
                <div className="blog-card__date-ribbon">
                  <span>
                    {new Date(post.created_at).toLocaleDateString("tr-TR", {
                      day: "numeric",
                      month: "long",
                    })}
                  </span>
                </div>
              </div>

              <article className="post-content">
                <div className="post-meta">
                  <FaRegCommentDots /> {comments.length} Yorum
                </div>
                <h1 className="post-title">{post.title}</h1>
                <div
                  className="post-body"
                  dangerouslySetInnerHTML={{ __html: post.content }}
                ></div>
              </article>

              <section className="comment-list-section">
                <h3 className="section-subtitle">{comments.length} Yorum</h3>
                {comments.length > 0 ? (
                  comments.map((comment) => (
                    <div key={comment.id} className="comment-item">
                      <div className="comment-author">
                        {comment.author_name}
                      </div>
                      <div className="comment-date">
                        {new Date(comment.created_at).toLocaleDateString(
                          "tr-TR"
                        )}
                      </div>
                      <p className="comment-text">{comment.comment_text}</p>
                    </div>
                  ))
                ) : (
                  <p>
                    Bu yazıya henüz hiç yorum yapılmamış. İlk yorumu siz yapın!
                  </p>
                )}
              </section>

              <section className="comment-form-section">
                <h3 className="section-subtitle">Yorumunuz</h3>
                <form className="comment-form" onSubmit={handleCommentSubmit}>
                  <div className="form-row">
                    <div className="form-group">
                      <label htmlFor="name">Ad Soyad</label>
                      <input
                        type="text"
                        id="name"
                        placeholder="Adınız ve Soyadınız"
                        value={commentAuthor}
                        onChange={(e) => setCommentAuthor(e.target.value)}
                        required
                      />
                    </div>
                  </div>
                  <div className="form-group">
                    <label htmlFor="comment">Yorumunuz</label>
                    <textarea
                      id="comment"
                      rows="6"
                      placeholder="Yorumunuzu buraya yazın..."
                      value={commentText}
                      onChange={(e) => setCommentText(e.target.value)}
                      required
                    ></textarea>
                  </div>
                  <div className="form-actions">
                    <button type="submit" className="submit-button">
                      Gönder
                    </button>
                  </div>
                  {formMessage && <p className="form-message">{formMessage}</p>}
                </form>
              </section>
            </div>

            <div className="sidebar-column">
              <Sidebar />
            </div>
          </>
        ) : null}
      </div>
    </div>
  );
};

export default SinglePostPage;
